<template>
  <div class="tw-flex tw-items-center tw-gap-1 tw-justify-end">
    <WdsText size="sm" weight="medium">{{ column.currency }}</WdsText>
    <WdsText size="sm" weight="medium">{{ formattedAmount }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestTotalAmountColumn = graphql(`
  fragment PaymentRequestTotalAmountColumn on PaymentRequest {
    id
    currency
    netAmount(accountType: COMPANY)
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestTotalAmountColumn>
}>()

const column = computed(() => useFragment(PaymentRequestTotalAmountColumn, props.row))

const formattedAmount = computed(() =>
  column.value.netAmount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
)
</script>
